import {
    ArcElement,
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Filler,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    RadarController,
    RadialLinearScale,
    Title,
    Tooltip,
} from 'chart.js';

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const centerTextPlugin = {
    id: 'centerText',
    afterDraw: (chart) => {
        const centerConfig = chart.config.options.elements?.center;
        if (!centerConfig) return;

        const { ctx, chartArea: { top, right, bottom, left } } = chart;
        const chartAreaWidth = right - left;
        const chartAreaHeight = bottom - top;
        const refSize = Math.min(chartAreaWidth, chartAreaHeight);

        if (refSize <= 0) return;

        const scaleFactor = refSize / 180;
        const scaledFontSize = clamp(
            Math.round((centerConfig.fontSize ?? 28) * scaleFactor),
            16,
            36
        );
        const scaledSubFontSize = clamp(
            Math.round((centerConfig.subFontSize ?? 10) * scaleFactor),
            8,
            13
        );

        ctx.save();
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        const centerX = (left + right) / 2;
        const relativeYOffset = centerConfig.yOffset
            ? (centerConfig.yOffset / 100) * chart.height
            : 0;
        const centerY = ((top + bottom) / 2) + relativeYOffset;

        ctx.font = `700 ${scaledFontSize}px 'Roboto', sans-serif`;
        ctx.fillStyle = centerConfig.color || '#111827';
        ctx.fillText(
            centerConfig.text,
            centerX,
            centerY - (centerConfig.subText ? scaledSubFontSize * 0.55 : 0)
        );

        if (centerConfig.subText) {
            ctx.font = `600 ${scaledSubFontSize}px 'Roboto', sans-serif`;
            ctx.fillStyle = centerConfig.subColor || '#6B7280';
            ctx.fillText(
                centerConfig.subText,
                centerX,
                centerY + (scaledFontSize * 0.52)
            );
        }

        ctx.restore();
    },
};

ChartJS.register(
    ArcElement,
    BarElement,
    CategoryScale,
    Filler,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    RadarController,
    RadialLinearScale,
    Title,
    Tooltip,
    centerTextPlugin
);

ChartJS.defaults.font.family = "'Roboto', sans-serif";
ChartJS.defaults.font.size = 12;
ChartJS.defaults.font.weight = '500';
